<template>
  <div class="subscription-page">
    <article>
      <section class="text-center">
        <h3 class="text-secondary">
          {{ $filters.whitespacedPunctuation(subscription.getTitle()) }}
        </h3>

        <img
          v-if="subscription.getId()"
          :src="subscription.getImg() || require('@etab/assets/img/subscription.svg')"
          alt="subscription-img"
          :draggable="false"
        />

        <p>
          {{ $filters.whitespacedPunctuation(subscription.getSubtitle()) }}
        </p>
      </section>

      <section class="text-left">
        <QList>
          <QItem v-for="point in subscription.getSellingPoints()" :key="point">
            <QItemSection avatar>
              <QIcon color="primary-medium" name="icon-f-check" />
            </QItemSection>
            <QItemSection>
              <QItemLabel>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="text-bold" v-html="point" />
              </QItemLabel>
            </QItemSection>
          </QItem>
        </QList>
      </section>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <section v-html="subscription.getSanitizedMessage()" />

      <section>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="asterisk" v-html="subscription.getSanitizedSubtext()" />
      </section>
    </article>

    <footer>
      <QBtn
        v-if="subscription.hasOkBtn()"
        type="button"
        color="secondary"
        class="btn-navigation full-width"
        no-caps
        :label="subscription.getOkBtnLabel()"
        @click="okBtnAction"
      />
      <br />
      <QBtn
        v-if="subscription.hasNokBtn()"
        type="button"
        flat
        text-color="black"
        color="white"
        class="full-width"
        no-caps
        :label="subscription.getNokBtnLabel()"
        @click="nokBtnAction"
      />
    </footer>
  </div>
</template>

<script>
  import { EtabSubscriptionService } from "@core/services";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { SubscriptionModel } from "@core/models";
  import { JavascriptHelpers } from "@core/helpers";
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    props: {
      demandId: {
        type: [String, Number],
        default: undefined,
      },
    },
    emits: ["giveFeedback", "cancelOrGoBack"],
    data() {
      return {
        subscription: new SubscriptionModel(),
      };
    },
    created() {
      this.initializeData();
    },

    methods: {
      async initializeData() {
        try {
          let subscription;
          this.$_startGlobalLoading();
          if (this.demandId) {
            subscription = await EtabSubscriptionService.getSubscriptionContentFromId({ demandId: this.demandId });
          } else {
            subscription = await EtabSubscriptionService.getSubscriptionContent();
          }
          this.subscription = new SubscriptionModel(subscription);
        } catch (error) {
          const message = error.response?.data;
          NotificationsManager.error({ message });
          // if there is no subscription content it's because the user is already sub we directly redirect him to upfront
          this.goToUpfront();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      proceedOrGoBack() {
        if (this.demandId) {
          return this.$router.push({ name: ETAB_ROUTES.creationSuccess.name }).catch((suppressedError) => {});
        }
        return this.$router.go(-1);
      },
      goToUpfront() {
        const demandId = this.demandId;
        return this.$router.push({ name: ETAB_ROUTES.upfront.name, params: { demandId } }).catch((suppressedError) => {});
      },
      okBtnAction() {
        // Safari is blocking any call to window.open() which is made inside an async call
        // so we divide the ok action in two functions:
        // 1 - the opening of url (if any)
        // 2 - the async feedback
        if (this.subscription.hasMandateUrl()) {
          JavascriptHelpers.openUrl(this.subscription.getMandateUrl(), "_blank");
        }
        this.asyncOkBtnAction();
      },
      asyncOkBtnAction() {
        const highlightId = this.subscription.getId();
        this.$emit("giveFeedback", { highlightId, isInterested: true, notifyUser: true });
        this.proceedOrGoBack();
      },
      nokBtnAction() {
        this.$emit("cancelOrGoBack");
        const highlightId = this.subscription.getId();
        this.$emit("giveFeedback", { highlightId, isInterested: false, notifyUser: true });
      },
    },
  };
</script>

<style lang="scss">
  .subscription-page {
    section {
      margin-bottom: 20px;
    }

    img {
      max-height: 200px;
      max-width: 275px;
      margin: 15px 0;
    }

    footer {
      padding: 20px;
      .q-btn {
        margin: 5px 0;
      }
    }
  }
</style>
